/*
 *  I15DIMSILOBOISI18n.ts
 *
 *  Created by Sébastien Hecart on 2022-06-19 18:55:20 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

export default {
  I15DIMSILOBOIS_SECTION_0_TITLE: "Calculez les dimensions d'un silo bois en fonction des consommation",
  I15DIMSILOBOIS_I04DIMPUISCONS: 'Calcul Déperdition Selon bilan de consommation',
  I15DIMSILOBOIS_I04DIMPUISSCHAUD: 'Calcul Déperdition selon la surface habitable',
  I15DIMSILOBOIS_in_deperdition: 'Déperdition',
  I15DIMSILOBOIS_in_temp_consigne: 'Température de consigne',
  I15DIMSILOBOIS_in_tempExtBase: 'Température de base ext.',
  I15DIMSILOBOIS_in_puissance_nominale_chaudiere: 'Puissance nominale chaudière',
  I15DIMSILOBOIS_dju_uuid: 'DJU',
  I15DIMSILOBOIS_material_uuid: '',
  I15DIMSILOBOIS_I15MASVOLAPHUML: "Calcul Masse volumique en fonction de l'humidité",
  I15DIMSILOBOIS_in_masse_volumique: 'Masse volumique du combustible',
  I15DIMSILOBOIS_res_pci_combu: 'PCI du combustible',
  I15DIMSILOBOIS_in_renderement_install_bois: 'Rendement installation Bois',
  I15DIMSILOBOIS_SECTION_1_TITLE: '',
  I15DIMSILOBOIS_: 'DJUs et Volume/mois',
  I15DIMSILOBOIS_SECTION_2_TITLE: 'Résultats',
  I15DIMSILOBOIS_duration_uuid: '',
  I15DIMSILOBOIS_res_silo_rotatif: 'Volume Silo carré à Déssilage rotatif',
  I15DIMSILOBOIS_res_silo_racleur: 'Volume Silo carré à échelles racleurs',
  I15DIMSILOBOIS_res_silo_cylindrique: 'Volume Silo cylindrique',
  I15DIMSILOBOIS_res_volume_moyen: 'Volume moyen utile '
}
